import http from "@/http-common";
import filehttp from "@/http-file-common";

class ManualInfoDataService {
  getManual(data: any): Promise<any> {
    return http.api.post("/getManual/", data);
  }

  getManualEdit(data: any): Promise<any> {
    return http.api.post("/getManualEdit/", data);
  }

  getManualFilebyName(data: any): Promise<any> {
    if(data.filename.split(".")[1] == "pdf" || data.filename.split(".")[1] == "PDF"){
      return http.api.post("/getManualFilebyName/", data);
    }
    return filehttp.api.post("/getManualFilebyName/", data);
  }

  addManualInfo(data: any): Promise<any> {
    return http.api.post("/addManualInfo/", data);
  }

  updateManualInfo(data: any): Promise<any> {
    return http.api.post("/updateManualInfo/", data);
  }

  deleteManualInfo(data: any): Promise<any> {
    return http.api.post("/deleteManualInfo/", data);
  }

  getCategory(data: any): Promise<any> {
    return http.api.post("/getCategory/", data);
  }

  addCategoryInfo(data: any): Promise<any> {
    return http.api.post("/addCategoryInfo/", data);
  }

  updateCategoryInfo(data: any): Promise<any> {
    return http.api.post("/updateCategoryInfo/", data);
  }

  deleteCategoryInfo(data: any): Promise<any> {
    return http.api.post("/deleteCategoryInfo/", data);
  }
}

export default new ManualInfoDataService();
